// A revíziószabály DOM nélküli magja: melyik Markdown-fájl tartozik egy
// oldalhoz egy kiválasztott programverzióban (lásd ../../data-store.md
// "Verziók", "from/until"). EGY helyen él, mert hárman használják: a kliens
// (app.ts — a fa, az oldal és a keresés hatóköre), a build
// (../assistant-meta.mjs — a fájlonkénti "visibleIn" lista) és a tesztek.
// A search.ts-hez hasonlóan nincs relatív importja, és csak "törölhető"
// TS-szintaxist használ (nincs enum, namespace, paraméter-property), így a
// Node a build-szkriptekből és a tesztekből közvetlenül betölti.
// Kiadási dátum, azonos napon a felirat számérzékeny ("SP9" < "SP10")
// összevetése — ugyanaz a sorrend, mint a ../help-versions.mjs
// compareVersions()-é.
export function buildVersionOrder(versions) {
    const collator = new Intl.Collator("hu", { numeric: true, sensitivity: "base" });
    const ascending = [...versions].sort((left, right) => left.releaseDate.localeCompare(right.releaseDate) || collator.compare(left.label, right.label));
    return new Map(ascending.map((version, index) => [version.id, index]));
}
// A versionId-ben érvényes fájl, vagy undefined, ha az oldal abban a
// verzióban nem létezik: a legkésőbbi olyan revízió, amelynek "from"-ja nem
// későbbi a verziónál, hacsak az "until"-ja (inkluzív) már lejárt. Ismeretlen
// verzióra hivatkozó "from" kimarad, ismeretlen "until" nem korlátoz. A
// változásnapló (versionFile) minden verzióban a saját fájlja.
export function resolveTargetFile(item, versionId, versionOrder) {
    if (item.versionFile) {
        return item.versionFile.replace("{version}", versionId);
    }
    if (!item.revisions) {
        return undefined;
    }
    const versionIndex = versionOrder.get(versionId);
    if (versionIndex === undefined) {
        return undefined;
    }
    let candidate;
    for (const revision of item.revisions) {
        const fromIndex = versionOrder.get(revision.from);
        if (fromIndex === undefined || fromIndex > versionIndex) {
            continue;
        }
        if (!candidate || fromIndex > (versionOrder.get(candidate.from) ?? -1)) {
            candidate = revision;
        }
    }
    if (!candidate) {
        return undefined;
    }
    if (candidate.until !== undefined) {
        const untilIndex = versionOrder.get(candidate.until);
        if (untilIndex !== undefined && untilIndex < versionIndex) {
            return undefined;
        }
    }
    return candidate.file;
}
// Az oldalak versionId-ben érvényes fájljai — a keresés hatóköre.
export function visibleFiles(items, versionId, versionOrder) {
    const files = new Set();
    for (const item of items) {
        const file = resolveTargetFile(item, versionId, versionOrder);
        if (file) {
            files.add(file);
        }
    }
    return files;
}
